import DOMPurify from 'dompurify';
const ALLOWED_TAGS = ['b', 'i', 'strong', 'a', 'ul', 'ol', 'p', 'hr'];
const ALLOWED_ATTR = ['href', 'title'];
export function sanitizeMarkdown(markdown) {
    // Temporarily escape autolinks
    const escaped = markdown.replace(/<(https?:\/\/[^>]+)>/g, '___AUTOLINK___$1___AUTOLINK___');
    const sanitized = DOMPurify.sanitize(escaped, {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
    });
    // Restore autolinks
    return sanitized.replace(/___AUTOLINK___([^_]+)___AUTOLINK___/g, '<$1>');
}
export const listConfig = {
    renderLabel: ({ label, listType, checked }) => {
        if (checked == null) {
            if (listType === 'bullet')
                return '•';
            return label; // e.g. '1.', '2.', ...
        }
        return checked ? '[x]' : '[ ]';
    },
};
//# sourceMappingURL=config.js.map